import { createReducer } from '@reduxjs/toolkit';
import { InsuranceFileState, UserInsuranceInfo } from '../types';
import * as Actions from '../actions';

export interface EVisitInsuranceState {
  userInfo?: UserInsuranceInfo | null;
  insuranceFiles: InsuranceFileState;
  isFetching: boolean;
  error: boolean;
}

export const defaultEVisitInsuranceState: EVisitInsuranceState = {
  userInfo: null,
  insuranceFiles: {
    primaryFront: {},
    primaryBack: {},
    secondaryFront: {},
    secondaryBack: {}
  },
  isFetching: false,
  error: false
};

const eVisitInsuranceReducer = createReducer(defaultEVisitInsuranceState, {
  [Actions.GET_USER_INSURANCE_INFO]: state => {
    state.isFetching = true;
    state.error = false;
  },
  [Actions.GET_USER_INSURANCE_INFO_SUCCESS]: (state, { payload }) => {
    state.userInfo = payload?.data;
    state.isFetching = false;
  },
  [Actions.GET_USER_INSURANCE_INFO_FAIL]: state => {
    state.error = true;
    state.isFetching = false;
  },
  [Actions.UPLOAD_INSURANCE_FILE]: state => {
    state.isFetching = true;
    state.error = false;
  },
  [Actions.UPLOAD_INSURANCE_FILE_FAIL]: state => {
    state.isFetching = false;
    state.error = true;
  },
  [Actions.UPLOAD_INSURANCE_FILE_SUCCESS]: state => {
    state.isFetching = false;
    state.error = false;
  },
  [Actions.SET_INSURANCE_FILE]: (state, { payload }) => {
    const insuranceType = payload.insuranceType as keyof InsuranceFileState;
    const insuranceFile = state.insuranceFiles[insuranceType];

    state.insuranceFiles = {
      ...state.insuranceFiles,
      [insuranceType]: { ...insuranceFile, ...payload }
    };
  },
  [Actions.RESET_INSURANCE_FILE]: (state, { payload }) => {
    const insuranceType = payload.insuranceType as keyof InsuranceFileState;

    state.insuranceFiles = {
      ...state.insuranceFiles,
      [insuranceType]: {}
    };
  },
  [Actions.RESET_INSURANCE_FILES]: state => {
    state.insuranceFiles = { ...defaultEVisitInsuranceState.insuranceFiles };
  }
});

export default eVisitInsuranceReducer;
